import React, { useState, useEffect, useMemo } from "react";
import {
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  Image,
  Input,
  Stack,
  Text,
  Textarea,
  useToast,
  FormLabel,
  Center,
  Box,
  VStack,
  Spacer,
  IconButton,
  Spinner,
  Grid,
  GridItem,
  useColorMode,
} from "@chakra-ui/react";
import LandingFooter from "@/src/components/LandingFooter";
import { useForm } from "react-hook-form";
import { validateEmail } from "@/src/utils/validate-functions";
import { pricing } from "@/services/contact";
import LandingHeader from "@/src/components/LandingHeader";
import LandingShell from "@/src/layouts/LandingShell";
import useTranslation from "next-translate/useTranslation";
import TopBackground from "@/src/components/TopBackground";
import Link from "next/link";
import PocsHeader from "@/src/components/pocs/PocsHeader";
import useSWR from "swr";
import PocItem from "../components/pocs/PocItem";
import { getFetcher } from "../utils/fetcher";
import { useRouter } from "next/router";
import PocsSkeleton from "../components/pocs/PocsSkeleton";
import PocNotFound from "../components/pocs/PocsNotFound";
import EmptyPocs from "../components/pocs/EmptyPocs";
import PocPagination from "../components/pocs/PocPagination"; // Ajoutez cette ligne

const PocsShell = () => {
  return (
    <LandingShell>
      <LandingHeader />
      <TopBackground />
      <PocsContain />
      <LandingFooter />
    </LandingShell>
  );
};

const PocsContain = () => {
  const { t } = useTranslation();
  const { colorMode } = useColorMode(); // Ajoutez cette ligne
  const router = useRouter();

  const [page, setPage] = useState(1);

  // Construction de l'URL
  let url = router.query.search
    ? `/api/pocs/search?search=${router.query.search}&page=${page}`
    : `/api/pocs/feeds?page=${page}`;

  // Récupération des données
  let { data: poc_feed, error, isValidating } = useSWR([url], getFetcher, {
    onErrorRetry: (error) => {
      if (error.status === 404) return;
    },
  });
  
  const isLoading = isValidating && !poc_feed && !error;

  console.log('data search', poc_feed);

  let poc = poc_feed?.poc_feed?.results
    ? poc_feed?.poc_feed?.results
    : poc_feed?.poc_search?.results
    ? poc_feed?.poc_search?.results
    : poc_feed?.poc_feed;
  
  let data = useMemo(() => poc, [poc]);
  
  // Calcul des informations de pagination
  const totalCount = poc_feed?.poc_feed?.count || poc_feed?.poc_search?.count || 0;
  const hasNext = !!poc_feed?.poc_feed?.next || !!poc_feed?.poc_search?.next;
  const hasPrevious = !!poc_feed?.poc_feed?.previous || !!poc_feed?.poc_search?.previous;

  console.log(data);

  function tronquerTexte(texte, longueurMax) {
    if (texte.length <= longueurMax) {
      return texte;
    } else {
      let dernierePositionEspace = texte.lastIndexOf(" ", longueurMax);
      if (dernierePositionEspace === -1) {
        dernierePositionEspace = longueurMax;
      }
      const texteTronque = texte.slice(0, dernierePositionEspace);
      return texteTronque;
    }
  }

  // Fonctions de navigation
  const handleGoNext = () => {
    if (hasNext) {
      setPage(prev => prev + 1);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleGoPrevious = () => {
    if (hasPrevious && page > 1) {
      setPage(prev => prev - 1);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleGoToPage = (pageNumber) => {
    setPage(pageNumber);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Flex
      py={"0px"}
      w={"100vw"}
      direction={"column"}
      px={{ base: "20px", "2xl": "120px", "5xl": "450px" }}
      mb={"60px"}
    >
      <PocsHeader search={router.query.search} />

      <Flex direction={"column"} alignItems="center" position={"relative"}>
        {!isLoading ? (
          data?.length > 0 ? (
            <>
              <Grid
                zIndex={9}
                gap={{ base: "0px", "2xl": "10px", "3xl": "30px" }}
                templateColumns={{
                  base: "repeat(1, 1fr)",
                  md: "repeat(2, 1fr)",
                  lg: "repeat(3, 1fr)",
                }}
                w="full"
              >
                {data?.map((poc_item, index) => {
                  return (
                    <GridItem key={index}>
                      <PocItem
                        id={poc_item.id}
                        videoUrl={poc_item.url}
                        title={poc_item.title}
                        description={tronquerTexte(poc_item.description, 50)}
                      />
                    </GridItem>
                  );
                })}
              </Grid>
              
              {/* Composant de pagination */}
              <PocPagination
                colorMode={colorMode}
                objectCount={totalCount}
                hasPrevious={hasPrevious}
                hasNext={hasNext}
                goPrevious={handleGoPrevious}
                goNext={handleGoNext}
                pageCount={page}
                goToPage={handleGoToPage}
              />
            </>
          ) : (
            <EmptyPocs message={t("pocs:empty_poc_message")} />
          )
        ) : (
          <PocsSkeleton />
        )}
      </Flex>
    </Flex>
  );
};

export default PocsShell;